import { Box } from '@collinsonx/design-system/core';
import { ProductCategory } from '@collinsonx/utils/generatedTypes/graphql';
import useLocale from 'hooks/useLocale';
import { FC } from 'react';
import { replaceTranslationPlaceholder } from 'utils/translations';

interface Props {
  category?: ProductCategory;
  days: number;
}

const descriptionKeyByCategory: Partial<
  Record<ProductCategory, 'descriptionFastTrack' | 'descriptionRest'>
> = {
  [ProductCategory.FastTrack]: 'descriptionFastTrack',
  [ProductCategory.Rest]: 'descriptionRest',
};

const MaxPeriodMessage: FC<Props> = ({ category, days }) => {
  const { maxPeriod } = useLocale().lounge.errors;

  const descriptionKey = category && descriptionKeyByCategory[category];
  const description = descriptionKey
    ? maxPeriod[descriptionKey]
    : maxPeriod.description;

  return <Box>{replaceTranslationPlaceholder(description, { days })}</Box>;
};

export default MaxPeriodMessage;
